import { makeAutoObservable } from 'mobx';
import { AuthorizationModule } from './modules/authorization/AuthorizationModule';
import {
  IAuthorizationService,
  RegistrationGoal,
} from '../../infrastructure/types/features/auth/auth-types';
import { IAppLoaderNavigationService } from '../../infrastructure/types/features/navigation/navigation-types';
import { appStorage } from '../../infrastructure/storage/app-storage';
import { authDatasource } from '../../infrastructure/api/datasources/auth-datasource';
import { RouteID } from '../../infrastructure/types/features/navigation/navigation-types';
import type { IMetrikaService } from '../../../shared/infrastructure/types/common/metrika-types';

class CoreRoot {
  authorizationModule: AuthorizationModule;

  constructor(
    authorizationService: IAuthorizationService,
    private navigationService: IAppLoaderNavigationService,
    metrikaService: IMetrikaService<RegistrationGoal>,
  ) {
    makeAutoObservable(this, {});

    this.authorizationModule = new AuthorizationModule(
      authorizationService,
      appStorage,
      authDatasource,
      () => this.navigationService.reload(),
      () => this.navigationService.navigateReplacing(RouteID.LOGIN as RoutePath),
      () => this.navigationService.navigate(RouteID.REGISTER as RoutePath),
      () => this.navigationService.navigate(RouteID.ROOT as RoutePath),
      path => this.navigationService.navigate(path),
      () => this.navigationService.destroy(),
      metrikaService,
    );
  }
}

export { CoreRoot };
